import { SYNC_KEY_SEGURIDAD_USUARIOS_PLATAFORMA } from "../../../constantes";
import {
  UsuarioPlataformaItem,
  UsuariosPlataformaService,
} from "../../../shared/generated/grpc/plataforma_seguridad_usuarios_plataforma_pb";
import { UsuarioPlataformaResponse } from "../../../shared/response/seguridad/UsuarioPlataformaResponse";
import { ServiceGetListBase } from "../../../shared/services/base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/** Usuarios de Plataforma (`UsuariosPlataformaService`, gRPC): listado en memoria por nombre. */
export class UsuarioPlataformaService extends ServiceGetListBase<UsuarioPlataformaResponse> {
  static readonly instance = new UsuarioPlataformaService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_SEGURIDAD_USUARIOS_PLATAFORMA;
  protected readonly sortBy = "nombre";

  /** gRPC-Web (`ListUsuarios`): no eliminados. */
  protected async fetchItems(): Promise<UsuarioPlataformaResponse[]> {
    const r = await grpcCall(() => grpcClient(UsuariosPlataformaService).listUsuarios({}));
    return r.items.map(toUsuarioPlataformaResponse);
  }
}

/** Mensaje gRPC del usuario → `UsuarioPlataformaResponse`. Lo reusa el guardado. */
export function toUsuarioPlataformaResponse(u: UsuarioPlataformaItem): UsuarioPlataformaResponse {
  return {
    id: u.id,
    isEliminado: false,
    nombre: u.nombre,
    email: u.email,
    isActivo: u.isActivo,
    hasSuperAdmin: u.hasSuperAdmin,
    hasComercial: u.hasComercial,
    hasHardware: u.hasHardware,
    hasPilotos: u.hasPilotos,
    hasConductores: u.hasConductores,
    hasOficina: u.hasOficina,
  };
}
